import React, { forwardRef, useState } from "react";

import {
  FormControl,
  InputLabel,
  OutlinedInput,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { useTheme } from "@mui/material";
import ErrorField from "../error-field/ErrorField.component";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useTranslation } from "react-i18next";

const OutlinedInputComponent = forwardRef(
  (
    {
      required = false,
      label = "",
      fullWidth = true,
      type = "text",
      multiline,
      rows,
      error,
      ...props
    },
    ref
  ) => {
    const { t } = useTranslation()
    const theme = useTheme();
    const [showPassword, setShowPassword] = useState(false);
    const [newType, setNewType] = useState(type);

    const onClick = () => {
      if (showPassword) {
        setNewType("password");
      } else {
        setNewType("text");
      }
      setShowPassword(!showPassword);
    };
    return (
      <FormControl
        fullWidth={fullWidth}
        error={Boolean(error)}
        sx={{ ...theme.typography.customInput }}
      >
        <InputLabel htmlFor="outlined-adornment-email-login">
          {label}
        </InputLabel>
        <OutlinedInput
          inputRef={ref}
          type={newType}
          name={props.name}
          multiline={multiline}
          rows={rows}
          {...props}
          label={label}
          endAdornment={
            type === "password" && (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={onClick}
                  edge="end"
                  size="large"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            )
          }
          required={required}
        />
        {error ? <ErrorField message={t(error?.message)} /> : null}
      </FormControl>
    );
  }
);
export default OutlinedInputComponent;
